import { render, staticRenderFns } from "./MenuPc.vue?vue&type=template&id=74f89c98&scoped=true&"
import script from "./MenuPc.vue?vue&type=script&lang=js&"
export * from "./MenuPc.vue?vue&type=script&lang=js&"
import style0 from "./MenuPc.vue?vue&type=style&index=0&id=74f89c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f89c98",
  null
  
)

export default component.exports